var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCdtteamShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.491,
    height: 80.371,
    viewBox: "0 0 60.491 80.371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-188.74 -26.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.3,101.754c-3.6-5.225-8.425-6.738-14.016-8.491a63.943,63.943,0,0,1-7.684-2.787l-.031-.013-.029-.018a15.84,15.84,0,0,1-7.63-11.636,15.619,15.619,0,0,1,4.232-13.26l.035-.035.04-.032c3.078-2.468,4.662-4.855,4.841-7.3.157-2.151-.835-4.395-2.945-6.666l-.377-.407,4.941-10.458.674.2a64.759,64.759,0,0,0,18.637,2.87,64.763,64.763,0,0,0,18.636-2.87l.674-.2,4.941,10.458-.377.407c-2.112,2.271-3.1,4.515-2.945,6.666.179,2.44,1.762,4.827,4.841,7.3l.038.032.035.035a15.62,15.62,0,0,1,4.233,13.26,15.836,15.836,0,0,1-7.63,11.636l-.029.018-.032.013a63.9,63.9,0,0,1-7.687,2.787c-5.593,1.755-10.422,3.269-14.033,8.492l-.675.977Z",
    transform: "translate(0 3.99)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.338,30.119H212.3l1.222-3.767,1.223,3.767H218.7l-3.2,2.325,1.223,3.767-3.2-2.325-3.207,2.325,1.223-3.767Z",
    transform: "translate(5.467 0)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.013,34.862h3.962L197.2,31.1l1.223,3.767h3.954l-3.2,2.326,1.222,3.767-3.2-2.326-3.206,2.326,1.222-3.767Z",
    transform: "translate(0.913 1.323)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.937,36.713H204.9l1.223-3.767,1.223,3.767H211.3l-3.2,2.326,1.222,3.767-3.2-2.326-3.207,2.326,1.222-3.767Z",
    transform: "translate(3.403 1.84)",
    fill: "#c4000b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.739,36.714H219.7l1.222-3.767,1.223,3.767H226.1l-3.2,2.326,1.222,3.767-3.2-2.326-3.206,2.326,1.222-3.767Z",
    transform: "translate(7.532 1.84)",
    fill: "#c4000b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.663,34.862h3.962l1.222-3.767,1.223,3.767h3.954l-3.2,2.326,1.223,3.767-3.2-2.326-3.207,2.326,1.223-3.767Z",
    transform: "translate(10.022 1.323)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.8,101.075c-5.419-7.87-13.654-7.725-22.035-11.558-7.606-4.268-10.411-16.243-3.211-23.61,4.392-3.524,8.011-8.673,1.984-15.16l4.4-9.32a62.768,62.768,0,0,0,37.74,0l4.4,9.32c-6.029,6.487-2.41,11.636,1.984,15.16,7.2,7.367,4.395,19.342-3.213,23.61-8.38,3.833-16.615,3.689-22.053,11.558",
    transform: "translate(0.179 4.206)",
    fill: "#004218",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.264,49.868l2.981-6.3a60.662,60.662,0,0,0,35.224,0l2.98,6.3a70.589,70.589,0,0,1-41.186,0",
    transform: "translate(2.099 4.802)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,50.534c1.81.464,3.609.9,5.44,1.248V87.656c-2.11-.687-3.939-1.036-5.671-1.78V60.05a10.221,10.221,0,0,0,.231-9.516m18.832,44.529a21.075,21.075,0,0,0-2.893-2.633v-39.4c1.925.086,3.861.086,5.786,0v39.4a21.154,21.154,0,0,0-2.893,2.633m18.841-44.529c-1.819.464-3.609.9-5.447,1.248V87.656c2.119-.687,3.948-1.036,5.68-1.78V60.05a10.166,10.166,0,0,1-.233-9.516",
    transform: "translate(2.435 6.746)",
    fill: "#ffbf00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.8,62.952V84.14c1.713-.977,5.5-5.525,5.351-10.724-.31-7.367-2.759-8.182-5.351-10.465M229.172,51.868q-2.786.42-5.68.678V90.511a30.19,30.19,0,0,1,5.68-2.439Zm-21.841,0c1.858.28,3.746.5,5.681.678V90.511a30.494,30.494,0,0,0-5.681-2.439ZM196.7,62.952V84.14c-1.713-.977-5.5-5.525-5.36-10.724.32-7.367,2.766-8.182,5.36-10.465",
    transform: "translate(0.723 7.118)",
    fill: "#c4000b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.785,48.328c.463-.265.692-.4,1.145-.673a2.928,2.928,0,0,0,1.6,1.136c.413.114.67.037.728-.184l0-.015c.056-.215-.1-.377-.79-.746-1.088-.577-1.872-1.168-1.536-2.218l.005-.014a1.859,1.859,0,0,1,2.5-1.04,3.6,3.6,0,0,1,1.959,1.241c-.389.339-.585.506-.982.839a2.91,2.91,0,0,0-1.345-.9c-.353-.1-.568,0-.622.182l0,.014c-.069.234.082.4.776.758,1.151.6,1.848,1.154,1.618,2.131l0,.014c-.249,1.065-1.32,1.493-2.694,1.114a4.057,4.057,0,0,1-2.364-1.636",
    transform: "translate(2.523 5.051)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.151,48.446V48.43a2.845,2.845,0,0,1,3.149-2.452,2.727,2.727,0,0,1,2.188,1.262c-.464.325-.7.485-1.178.8a1.5,1.5,0,0,0-1.141-.715,1.354,1.354,0,0,0-1.439,1.282v.015a1.336,1.336,0,0,0,1.2,1.554,1.534,1.534,0,0,0,1.321-.554c.449.348.675.521,1.137.858a2.842,2.842,0,0,1-2.624,1.04,2.741,2.741,0,0,1-2.61-3.076",
    transform: "translate(4.85 5.472)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.542,46.242c1.692-.088,2.537-.165,4.222-.381.066.517.1.772.165,1.289-1.126.146-1.69.2-2.82.293l.07.907c1.04-.081,1.558-.133,2.594-.262.06.49.091.733.151,1.223-1.058.13-1.587.185-2.647.269.06.762.09,1.143.15,1.906-.642.05-.964.072-1.606.1-.111-2.138-.166-3.209-.278-5.347",
    transform: "translate(7.198 5.443)",
    fill: "#c4000b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.323,47.981l0-.015a2.852,2.852,0,0,1,2.109-3.4,2.772,2.772,0,0,1,2.514.407c-.327.469-.494.7-.836,1.168a1.519,1.519,0,0,0-1.329-.266,1.358,1.358,0,0,0-.909,1.707l0,.014a1.338,1.338,0,0,0,1.674,1.033,1.547,1.547,0,0,0,1.056-.985c.547.168.822.248,1.38.4a2.889,2.889,0,0,1-2.121,1.9,2.748,2.748,0,0,1-3.539-1.965",
    transform: "translate(9.347 5.044)",
    fill: "#c4000b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdtteamShield);
export default __webpack_public_path__ + "static/media/cdtteam-shield.57eecbf851395d931ee1ab4c1312a33d.svg";
export { ForwardRef as ReactComponent };